export const InputAccessory = () => {
  return null
}
